import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Nav from '../../components/userSecurityNav';
import Content from './content';
import Footer from '../../components/userSecurityFooter';
import { cacheUserInfo } from '../../services/api';

class Layout extends React.PureComponent {
    state = {
        userInfo: null,
    };
    componentDidMount = async () => {
        const userInfo = await cacheUserInfo();

        if (userInfo) {
            this.setState({ userInfo });
        }

        if (!userInfo) {
            location.href = '/login';
        }
    };
    render() {
        const { userInfo } = this.state;

        return userInfo ? (
            <div className={styles.layout}>
                <Nav cur={0} />
                <Content userInfo={userInfo} />
                <Footer />
            </div>
        ) : null;
    }
}

export default errorBoundary(Layout);
